export default __webpack_public_path__ + "static/media/geo.eeb9e854.png";